import { FC, ChangeEvent, useState, useEffect } from 'react';
import {
  Tooltip, Modal, Divider, Box,  IconButton, Typography, useTheme, CardHeader, Button,
  Container,
  Card
} from '@mui/material';
import { DataGrid, GridToolbar, GridValueGetterParams, GridRowParams } from '@mui/x-data-grid';
import axios from 'axios';
import { CryptoOrder, CryptoOrderStatus } from 'src/models/crypto_order';
import EditTwoToneIcon from '@mui/icons-material/EditTwoTone';
import DeleteTwoToneIcon from '@mui/icons-material/DeleteTwoTone';
import { useNavigate } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';
import Chip from '@mui/material/Chip';
import CircularProgress from '@mui/material/CircularProgress';
import CondolancePageHeader from './pageHeader';
import PageTitleWrapper from 'src/components/PageTitleWrapper';




interface CategoryListTableProps {
  className?: string;
}

interface Filters {
  status?: CryptoOrderStatus;
}


const applyFilters = (
  cryptoOrders: any[],
  filters: Filters
): CryptoOrder[] => {
  return cryptoOrders.filter((cryptoOrder) => {
    let matches = true;
    return matches;
  });
};

const applyPagination = (
  cryptoOrders: CryptoOrder[],
  page: number,
  limit: number
): CryptoOrder[] => {
  return cryptoOrders.slice(page * limit, page * limit + limit);
};
const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 480,
  //bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

const CondolenceList: FC<CategoryListTableProps> = ({ }) => {
  const [clickedID, setClickedID] = useState(null)
  const [open, setOpen] = useState(false);

  const handleOpen = (id) => {
    setOpen(true);
    setClickedID(id)
  }

  const handleClose = () => {
    setOpen(false);
    setClickedID(null)
  }

  const [Loading, setLoading] = useState(false)
  const [cryptoOrders, setcryptoOrdersPage] = useState([]);
  const [selectedCryptoOrders, setSelectedCryptoOrders] = useState([]);
  const selectedBulkActions = selectedCryptoOrders.length > 0;
  const [page, setPage] = useState<number>(0);
  const [limit, setLimit] = useState<number>(5);
  const [filters, setFilters] = useState<Filters>({
    status: null
  });
  const handlePageChange = (event: any, newPage: number): void => {
    setPage(newPage);
  };

  const handleLimitChange = (event: ChangeEvent<HTMLInputElement>): void => {
    setLimit(parseInt(event.target.value));
  };

  const filteredCryptoOrders = applyFilters(cryptoOrders, filters);
  const paginatedCryptoOrders = applyPagination(
    filteredCryptoOrders,
    page,
    limit
  );
  const selectedSomeCryptoOrders =
    selectedCryptoOrders.length > 0 &&
    selectedCryptoOrders.length < cryptoOrders.length;
  const selectedAllCryptoOrders =
    selectedCryptoOrders.length === cryptoOrders.length;
  const theme = useTheme();
  const navigate = useNavigate();
  const [deleteButton, setDeleteButton] = useState(false);

  const adminRows = cryptoOrders.filter((row) => row.role === 'Admin');

  const columns = [
    { field: 'name', headerName: 'Name', flex:1 },
    // {
    //   field: 'user',
    //   headerName: 'User',
    //   width: 170,
    //   valueGetter: (params) => params.row.user.name ,
    //   flex:1

    // },
    { field: 'status', headerName: 'Status', flex:1 },

    // { field: 'message', headerName: 'Message', flex:2},
    {
      field: 'message',
      headerName: 'Message',
      width: 700,
      renderCell: (params) => {
        return (
          <div
            dangerouslySetInnerHTML={{ __html: params.row.message }}
          />
        );
      },
    },
 
    {
      field: 'description',
      headerName: 'description',
      width: 700,
      renderCell: (params) => {
        return (
          <div
            dangerouslySetInnerHTML={{ __html: params.row.description }}
          />
        );
      },
    },
 
    {
      field: 'Actions',
      headerName: 'Actions',
      sortable: false,
      filterable: false,
      // flex: 1,
      disableClickEventBubbling: true,
      renderCell: (params) => {
        return (
          <>
            <Tooltip title="Edit User" arrow>
              <IconButton
                sx={{
                  '&:hover': {
                    background: theme.colors.primary.lighter
                  },
                  color: theme.palette.primary.main
                }}
                color="inherit"
                size="small"
              >

                <EditTwoToneIcon fontSize="small"
                  onClick={() => navigate(`/condolance-messages/edit/${params?.row._id}
                  `)}
                />
              </IconButton>
            </Tooltip>

            <Tooltip title="Delete User" arrow>
              <IconButton
                sx={{
                  '&:hover': {
                    background: theme.colors.primary.lighter
                  },
                  color: theme.palette.primary.main
                }}
                color="inherit"
                size="small"
              >

                {params.row.role == "Admin" ? "" : (
                  <DeleteTwoToneIcon fontSize='small'
                    onClick={() => handleOpen(params.row._id)}
                    className="MuiButtonBase-root MuiButton-root MuiButton-contained MuiButton-containedPrimary"
                  />
                )}


              </IconButton>
            </Tooltip>


          </>

        );
      },
    },
  ];

  const handleDeleteUsers = async () => {
    try {
      setDeleteButton(true);
      for (const id of selectedCryptoOrders) {
        console.log("data is => ", id);
        await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/condolance/deleteCondolance/${id}`);
      }
      setDeleteButton(false);
      toast.success('Selected Condolance Deleted Successfully!', { position: "bottom-right" });
      setSelectedCryptoOrders([]);
      fetchCondolanceData();
    } catch (error) {
      setDeleteButton(false);
      toast.error(error?.response?.data?.message, { position: "bottom-right" });
    }
  };

  const fetchCondolanceData = async () => {
    setLoading(true)
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/condolance/getAllCondolances`);
      console.log(response,"dddddddddddddd");
      if (response?.data) {
        setLoading(false)
        const d = response?.data;
        const sortedNonPinnedPosts = d.sort((a, b) => {
          return +new Date(b.createdAt) - +new Date(a.createdAt);
        });
        setcryptoOrdersPage(sortedNonPinnedPosts)
      }
    } catch (err) {
      toast.error(err?.response?.data?.message, { position: "bottom-right" });
    }
  };

  useEffect(() => {
    fetchCondolanceData();
  }, []);

  const handleDeleteData = async (id: any) => {
    try {
      setDeleteButton(true)
      let data = await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/condolance/deleteCondolance/${id}`);
      setDeleteButton(false)
      toast.success('User Deleted Successfully!', { position: "bottom-right" });
      fetchCondolanceData();
      handleClose()
    } catch (error) {
      setDeleteButton(false)
      toast.error(error?.response?.data?.message, { position: "bottom-right" });
    }
  }


  useEffect(() => {
    
  }, [selectedCryptoOrders]);

  const isCheckboxDisabled = selectedCryptoOrders.some((row) => row.role === 'Admin');


  

  return (
    <>
   
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h3" component="h2">
            Are you sure to delete?
          </Typography>
          <hr />


          <Button type="submit" sx={{ mt: 2, mr: 2 }} variant="contained" onClick={() => handleDeleteData(clickedID)}
            disabled={deleteButton}
          >
            Yes
          </Button>

          <Button type="submit" sx={{ mt: 2 }} variant="contained" onClick={() => handleClose()}>
            Cancel
          </Button>

        </Box>
      </Modal>

      {/* <Card> */}
      <Container maxWidth="lg">
      <PageTitleWrapper>
      <CondolancePageHeader />
      </PageTitleWrapper>
      </Container>
      {/* </Card> */}

      <Container maxWidth="lg">
        <Card>

        <Box className="innerr_box container" sx={{ p: 3, width: "auto" }}>
          <Divider variant="middle" />
          <div className="table">
            <DataGrid
              rows={cryptoOrders}
              getRowId={(row) => row._id}
              columns={columns}
              className="mybonustable widthtable"
              slots={{ toolbar: GridToolbar }}
              checkboxSelection
          

              onRowClick={(params) => {
                if (params?.row?.name || params?.row?.email || params?.row?.mobile ||
                  params?.row?.gotra || params?.row?.fatherName || params?.row?.city || params?.row?.state ||
                  params?.row?.familyId) {
                  if (params.row.role === "Admin") {
                    toast.warning("Admin Can't Be Deleted", { position: "bottom-right" });
                  } else {
                    
                  }
                }
              }}
              isRowSelectable={(params: GridRowParams) => params.row.role !== "Admin"}


              onRowSelectionModelChange={(newSelection) => {

                setSelectedCryptoOrders(newSelection);
              }}

              slotProps={{
                toolbar: {
                  showQuickFilter: true,
                  quickFilterProps: { debounceMs: 500 }
                }
              }}
              initialState={{
                filter: {
                  filterModel: {
                    items: [],
                    quickFilterValues: ['']
                  }
                },
                pagination: {
                  paginationModel: { pageSize: 10, page: 0 }
                }
              }}
            />

          </div>
          <Button
            variant="contained"
            color="warning"
            onClick={handleDeleteUsers}
            disabled={selectedCryptoOrders.length === 0 || deleteButton}
            style={{ display: selectedCryptoOrders.length === 0 || deleteButton ? 'none' : 'block' }}
          >
            Delete Users
          </Button>
        </Box>
        </Card>
      </Container>

    </>

  );
};

export default CondolenceList;



